import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
import { InvoiceFragmentDoc } from '../../fragments/InvoiceFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type InvoiceQueryResult = { readonly __typename: 'Query', readonly invoice: { readonly __typename: 'Invoice', readonly cardId: string, readonly cardRecipient: string, readonly createdAt: any, readonly currencyCode: string, readonly id: string, readonly invoiceNumber: number, readonly status: string, readonly transactionId: string, readonly transactionTimestamp: any, readonly updatedAt: any, readonly userId: string, readonly customer: { readonly __typename: 'TransactionCustomer', readonly email: string, readonly address: { readonly __typename: 'TransactionAddress', readonly countryCode: string, readonly postalCode?: string | null, readonly city?: string | null, readonly region?: string | null, readonly firstLine?: string | null, readonly secondLine?: string | null } }, readonly item: { readonly __typename: 'TransactionItem', readonly id: string, readonly name?: string | null, readonly price: string }, readonly payment: { readonly __typename: 'TransactionPayment', readonly method: string, readonly card?: { readonly __typename: 'TransactionCard', readonly type?: string | null, readonly last4?: string | null } | null }, readonly totals: { readonly __typename: 'TransactionTotals', readonly subtotal: string, readonly tax: string, readonly discount: string, readonly total: string, readonly grandTotal: string } } };


export const InvoiceDocument = gql`
    query Invoice($id: ID!) {
  invoice(id: $id) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentDoc}`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQueryResult, InvoiceQueryVariables> & ({ variables: InvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQueryResult, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQueryResult, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQueryResult, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export function useInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceQueryResult, InvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceQueryResult, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceSuspenseQueryHookResult = ReturnType<typeof useInvoiceSuspenseQuery>;